import React, { Component } from 'react';

import api from '../../../api/';
import functions from '../../../functions/';

import ParadigmaTable from "../../../components/ParadigmaTable/"

class Empresas extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "NombreEmpresa",
                    accessor: "NombreEmpresa",
                    show: true,
                    className:"text-uppercase mr-4",
                },
                {
                    Header: "Driver",
                    id: "driver",
                    width: 200,
                    accessor: "driver",
                    show: true,
                    className: "text-lowercase",
                },
                {
                    Header: "Creado",
                    id: "CreationDate",
                    show: true,
                    accessor: d => functions.FormatDate(d.CreationDate),
                    className:"text-center",
                    width: 100,
                },
                {
                    id: "Estado",
                    accessor: d => <div className={`bg-${d.Estado} rounded`} style={{width:10, height:10}} />,
                    width: 20,
                    className:"m-auto",
                    filterable: false,
                    show: true,
                },
                {
                    Header: "Ultima Actualizacion",
                    id: "FUA_Config",
                    accessor: d => functions.FormatDate(d.FUA_Config),
                    className:"text-center",
                    width: 150,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[]}
                apiUrl={api.empresas.empresas}
                columns={this.state.columns}
                exportUrl={api.empresas.empresas}
                title={"Empresas"}
            />
        );
    }
}

export default Empresas;



// WEBPACK FOOTER //
// ./src/views/Empresas/Empresas/Empresas.js